import useCurrentCompanyMetadata from "./current-company-metadata"

export default function useGaMultiPropertyAccess() {
  return true
}

export function useGaMultiPropertyEnabled() {
  const metadata = useCurrentCompanyMetadata()
  const isGaMultiPropertyEnabled = Boolean(
    metadata?.settings?.flags?.ga_multi_property,
  )
  // ToDo: add metadata prop check
  return isGaMultiPropertyEnabled
}
